export const PILL_TYPES = {
  OUTLINED: "outlined",
  CONTAINED_SECONDARY: "containedSecondary",
  CONTAINED_WHITE: "containedWhite",
  DISABLED: "disabled",
};
